import firedux from '../firedux'
import store, {dispatch} from '../store'

import {USERS_VIEW_ENDPOINT} from '../../config/constants'

import setUsers from '../actions/set_users'

const onUsers = (snapshot) => {
  if (snapshot.exists()) dispatch(setUsers(snapshot.val()), store.getState().currentUser)
}

export const watchUsers = () => {
  const usersViewRef = firedux.ref.child(USERS_VIEW_ENDPOINT)
  usersViewRef.on('value', onUsers)
}

export const unwatchUsers = () => {
  const usersViewRef = firedux.ref.child(USERS_VIEW_ENDPOINT)
  usersViewRef.off('value', onUsers)
  dispatch(setUsers(null))
}




/** WEBPACK FOOTER **
 ** ./modules/shared/data/watchers/users.js
 **/